import { OfficerCaseRole, CaseStatus } from './enums';

export class UpdateCaseRequest {
  constructor(
    public OrganisationalID: string,
    public Name: string,
    public Status: CaseStatus,
    public Description: string,
    public UserUID: string,
    public Categories: string[],
    public Tags: string[]
  ) {}
}

export class NewFolderRequest {
  constructor(public Name: string) {}
}

export class CaseEvidenceRequest {
  constructor(public FileUid: string, public FolderUid?: string | null) {}
}

export class CaseLinkRequest {
  constructor(public CaseUID: string) {}
}

export class MoveEvidenceFileRequest {
  constructor(public CaseFolderUid: string | null, public Files: string[]) {}
}

export class RemoveCaseEvidenceRequest {
  constructor(public FileUID: string) {}
}

export class AddCaseMemberRequest {
  constructor(public Role: OfficerCaseRole, public UserUid: string) {}
}

export class RemoveCaseMemberRequest {
  constructor(public UserUID: string) {}
}

export class PostCommentRequest {
  constructor(public Comment: string) {}
}

export class InviteCaseGuestsRequest {
  constructor(public EmailAddresses: string[], public UserCaseRole: OfficerCaseRole, public Description: string) {}
}

export class DownloadAllCaseEvidenceRequest {
  constructor(public Description: string) {}
}

export class DownloadCaseRequest {
  constructor(public caseUid: string, public requestUid: string) {}
}
